import React from 'react';
import DisclaimerBox from '../components/DisclaimerBox';

const SECTIONS = [
  { t: 'Information We Collect', d: 'We collect the details you provide at checkout and via our contact form \u2014 name, email, phone, shipping address and order notes \u2014 solely to process and fulfil your orders.' },
  { t: 'How We Use Your Information', d: 'Your information is used to process payments, dispatch orders, provide order updates and respond to enquiries. We do not sell your personal information.' },
  { t: 'Payments', d: 'Payment is by bank transfer (manual payment) in AUD. We do not process card payments online and do not store any payment card details on our servers.' },
  { t: 'Data Security', d: 'We take reasonable steps to protect your information. Sensitive credentials are stored securely and never exposed publicly.' },
  { t: 'Cookies', d: 'We may use minimal cookies and local storage to maintain your cart and improve your browsing experience.' },
  { t: 'Contact', d: 'For privacy enquiries, contact support@australianluxepeptides.com.' },
];

export default function Privacy() {
  return (
    <div className="bg-alp-black min-h-screen">
      <div className="border-b border-alp-line">
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-16 text-center">
          <p className="text-alp-gold text-xs tracking-[0.3em] uppercase mb-3">Legal</p>
          <h1 className="font-serif text-5xl md:text-6xl text-alp-cream">Privacy Policy</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-16">
        <div className="space-y-8">
          {SECTIONS.map((s, i) => (
            <div key={i}>
              <h3 className="font-serif text-2xl text-alp-cream mb-2">{s.t}</h3>
              <p className="text-alp-gray leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-12"><DisclaimerBox /></div>
      </div>
    </div>
  );
}
